import SectionHeading from './SectionHeading'

const defaultHeading = {
    pre: 'Discover What ',
    highlight: 'Top Roofing Companies',
    post: ' Are Doing To Win More Jobs. Get Free Report',
}

const defaultSubheading =
    "Before you invest a dollar in marketing, see what's actually working for roofing companies in 2025."

const defaultReportItems = [
    'Average ROI roofers are getting from direct mail vs. Facebook & Google Ads',
    'Real campaign numbers — cost per call, cost per booked inspection, cost per contract',
    'Highest-converting postcard + letter styles used after storm events.',
    'Best-performing homeowner targeting lists (age of roof, storm damage zones, insurance claim neighborhoods)',
    'How top roofing companies are automating follow-up and staying top-of-mind',
]

const defaultImage = {
    src: '/assets/roofers/roofers-screwing-v3.png',
    alt: 'Roofer working on roof',
}

function CheckmarkIcon() {
    return (
        <svg
            className="w-6 h-6 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5 13l4 4L19 7"
                stroke="#F15A22"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default function FreeReportSection(props) {
    const heading = props?.heading || defaultHeading
    const subheading = props?.subheading || defaultSubheading
    const reportItems =
        Array.isArray(props?.reportItems) && props.reportItems.length > 0
            ? props.reportItems
            : defaultReportItems
    const image = props?.image || defaultImage

    return (
        <section className="relative my-0 py-14 sm:py-16 lg:py-20">
            <div className="container mx-auto px-4">
                {/* Heading */}
                <div className="max-w-4xl mx-auto mb-6">
                    <SectionHeading textAlignment="text-center">
                        {heading.pre}
                        <span className="text-olm">{heading.highlight}</span>
                        {heading.post}
                    </SectionHeading>
                </div>

                {/* Subheading */}
                <div className="max-w-3xl mx-auto text-center mb-12 lg:mb-16">
                    <p className="text-base sm:text-lg lg:text-xl text-gray-600">
                        {subheading}
                    </p>
                </div>

                {/* Two Column Layout */}
                <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
                    {/* Left Column - Report Details */}
                    <div className="space-y-6">
                        <div>
                            <h3 className="text-xl sm:text-2xl font-bold text-olm-new-black mb-2">
                                Free Download: Roofing Industry Marketing Report
                            </h3>
                            <p className="text-base sm:text-lg font-semibold text-olm-new-black mb-6">
                                Inside this complimentary report, you&apos;ll
                                discover:
                            </p>
                        </div>

                        {/* Report Items List */}
                        <div className="space-y-4">
                            {reportItems.map((item, idx) => (
                                <div
                                    key={idx}
                                    className="flex items-start gap-3 pb-4 border-b border-gray-200 last:border-b-0">
                                    <CheckmarkIcon />
                                    <p className="text-base sm:text-lg text-olm-new-black leading-relaxed">
                                        {item}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right Column - Image */}
                    <div className="relative">
                        <div className="rounded-5xl overflow-hidden shadow-2xl">
                            <img
                                src={image.src}
                                alt={image.alt}
                                className="w-full h-auto object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
